module.exports = __webpack_public_path__ + "static/media/pinPurple.b1254053.svg";